import { render, staticRenderFns } from "./SettingsHolidays.vue?vue&type=template&id=0d055aa8"
import script from "./SettingsHolidays.vue?vue&type=script&lang=js"
export * from "./SettingsHolidays.vue?vue&type=script&lang=js"
import style0 from "./SettingsHolidays.vue?vue&type=style&index=0&id=0d055aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports